import axios from 'axios';

import { decrementBlockCounter, incrementBlockCounter, unBlockUi } from '../actions/actionCreator';
import { appStore as store } from '../index';
import AuthInterceptor from '../utils/AuthInterceptor';

let aemHostClient = axios.create();
aemHostClient.defaults.headers.post['Content-Type'] = 'application/json';
aemHostClient.defaults.timeout = 300000;

// Add a AEMHost request interceptor
const ejectAEMHostRequestInterceptorRef = aemHostClient.interceptors.request.use(function (config) {

  // attaching auth token
  AuthInterceptor.attachToken(config);

  if (config.noBlocking === undefined || config.noBlocking === false) {
    store.dispatch(incrementBlockCounter());
  }
  return config;
}, function (error) {
  store.dispatch(unBlockUi());
  return Promise.reject(error);
});

// Add a AEMHost response interceptor
const ejectAEMHostResponseInterceptorRef = aemHostClient.interceptors.response.use(function (response) {
  if (response.config.noBlocking === undefined || response.config.noBlocking === false) {
    store.dispatch(decrementBlockCounter());
  }
  return response;
}, function (error) {
  store.dispatch(unBlockUi());
  return Promise.reject(error);
});

export { aemHostClient, ejectAEMHostRequestInterceptorRef, ejectAEMHostResponseInterceptorRef };




// WEBPACK FOOTER //
// ./src/restClient/aemHostRestClient.js